import React, { useState } from 'react';
import './InitialOverlayComponent.css';
import config from '../../../config/config'; 

const InitialOverlay : React.FC<any> = ({onOverlayLogin}) => {
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validKey = config.overlayPassword; // Replace with your actual key logic

  const handleChange = (e :any) => {
    setKey(e.target.value);
  };

  const handleSubmit = async (e:  any) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    if (key === validKey) {
      //hide overlay
      onOverlayLogin(true);
      const overlay = document.querySelector('.overlay');
      if (overlay) {
        overlay.classList.add('hidden');
      }
    } else {
      setError('Invalid key. Please try again.');
    }

    setIsLoading(false);
  };

  return (
    //user show_overlay value to enable and disable overlay

    <div className="overlay" >
      <div className="login-box">
        <h2>LTIM Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={key}
            onChange={handleChange}
            placeholder="Enter access key"
            required
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Verifying...' : 'Submit'}
          </button>
          {error && <p className="error">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default InitialOverlay;
